import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "q-gutter-lg justify-center q-pb-xl" }

import BaseCard from '@/components/Works/baseCard.vue';
import TitleCard from '@/components/utils/TitleCard.vue';
import { titles, contents } from './Contents'


export default /*#__PURE__*/_defineComponent({
  __name: 'TopPage',
  setup(__props) {

function getImgPath(src: string, key: string) {
  const folderName = () => {
    switch (key) {
      case 'world':
        return 'Worlds/'
      case 'other':
        return 'Others/'
      default:
        return ''
    }
  }
  
  return require(`@/assets/Works/${folderName()}${src}`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(titles), (title, key) => {
    return (_openBlock(), _createElementBlock("div", {
      key: title,
      class: "article"
    }, [
      _createVNode(TitleCard, {
        title: title.title.toUpperCase(),
        "sub-title": title.subTitle,
        abst: title.desc
      }, null, 8, ["title", "sub-title", "abst"]),
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contents)[key], (card) => {
          return (_openBlock(), _createBlock(BaseCard, {
            key: card,
            label: card.cardLabel ?? title.cardLabel,
            "to-name": card.to,
            imgsrc: getImgPath(card.imgsrc, key.toString()),
            title: card.title,
            text: card.text
          }, null, 8, ["label", "to-name", "imgsrc", "title", "text"]))
        }), 128))
      ])
    ]))
  }), 128))
}
}

})